import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M1.354.646L7.707 7l-6.353 6.354-.708-.707L6.293 7 .646 1.354l.708-.708z" /></svg>;